<div class="modal-header">
    <mat-icon class="clickable text-transparent">&nbsp;&nbsp;&nbsp;&nbsp;</mat-icon>
    <h4 class="modal-title">Edit {{integrationName}} Integration</h4>
    <mat-icon class="close clickable me-4" (click)="onClose()">close</mat-icon>
</div>
<div class="loader p-4 text-center" *ngIf="loading">
    <mat-spinner diameter="30"></mat-spinner>
</div>

<form *ngIf="!loading && integrationForm" [formGroup]="integrationForm" class="integrationForm">
    <div class="modal-body">
        <div *ngFor="let provider_field of provider_fields">
            <label [for]="provider_field.key">{{ provider_field.label }}</label>
            <input *ngIf="provider_field.type === 'text' || provider_field.type === 'url'" [type]="provider_field.type"
                [formControlName]="provider_field.key" [id]="provider_field.key" class="form-control" />

            <select *ngIf="provider_field.type === 'select'" [formControlName]="provider_field.key"
                [id]="provider_field.key" class="form-control">
                <option *ngFor="let opt of provider_field.options" [value]="opt">{{ opt }}</option>
            </select>

            <div
                *ngIf="integrationForm.get(provider_field.key)?.invalid && integrationForm.get(provider_field.key)?.touched">
                <small class="text-danger">{{ provider_field.label }} is required</small>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="submit" class="btn btn-sm mx-2 btn-primary" (click)="onSubmit()"
            [disabled]="!integrationForm.valid">Update Integration</button>
    </div>
</form>